module.exports = __webpack_public_path__ + "meshes/gizmo.obj";